import React, { useState } from 'react';
import { BrowserRouter, Link, Route, Routes } from "react-router-dom";

import Vcard from "./Vcard";
import Work from "./Work";
import GitHub from "./GitHub";
import Education from "./Education";
import About from "./About";
import Courses from "./Courses";

import paw from "../images/square-paw.png";


function Portfolio() {

    const [isOpen, onClickNav] = useState(false);
    const [isActive, setActive] = useState(false);
    const toggle = () => {
        onClickNav(isOpen === false ? true : false);
        setActive(!isActive);
    }

    return (
        <BrowserRouter basename="/portfolio">

            <nav className="navbar is-transparent" role="navigation" aria-label="main navigation" style={{ background: 'linear-gradient(to right, rgba(60,60,60,1) 0%, rgba(255,255,255,0.5) 100%)', fontFamily: 'Raleway', textTransform: 'uppercase' }}>
                <div className="navbar-brand">
                    <Link to="/" className="navbar-item">
                        <figure className="image is-32x32">
                            <img src={paw} alt="" />
                        </figure>
                    </Link>

                    <span role="button" className={`navbar-burger burger ${isActive ? "is-active" : ""}`} aria-label="menu" aria-expanded="false" onClick={toggle}>
                        <span aria-hidden="true"></span>
                        <span aria-hidden="true"></span>
                        <span aria-hidden="true"></span>
                    </span>
                </div>

                <div className={`navbar-menu ${isActive ? "is-active" : ""}`} onClick={toggle}>
                    <div className="navbar-start">
                        <Link to="/" className="navbar-item">Home</Link>
                        <Link to="/work" className="navbar-item">Work</Link>
                        <Link to="/github" className="navbar-item">GitHub</Link>
                        <Link to="/education" className="navbar-item">Education</Link>
                        <Link to="/courses" className="navbar-item">Courses</Link>
                        <Link to="/about" className="navbar-item">About</Link>
                    </div>
                </div>

            </nav>
                
            <Routes>
                <Route exact path="/" element={<Vcard />} />
                <Route path="/work" element={<Work />} />
                <Route path="/github" element={<GitHub />} />
                <Route path="/education" element={<Education />} />
                <Route path="/courses" element={<Courses />} />
                <Route path="/about" element={<About />} />
            </Routes>
        </BrowserRouter>
    )
}

export default Portfolio;